<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="10"
        offset-md="1"
        lg="10"
        offset-lg="1"
        xl="8"
        offset-xl="2"
      >
        <template v-if="showSkeleton">
          <v-skeleton-loader
            class="mb-6"
            type="card-avatar, article, list-item-avatar, list-item-avatar"
          ></v-skeleton-loader>
        </template>
        <template v-if="!showSkeleton && profile != null">
          <v-sheet class="pa-5">
            <v-row no-gutters align="start" justify="center">
              <v-col class="shrink mr-4">
                <v-img
                  width="150"
                  height="150"
                  aspect-ratio="1"
                  :src="profile.info.image"
                ></v-img>
              </v-col>
              <v-col class="grow">
                <div class="title">{{ profile.info.displayName }}</div>
                <div>
                  <p>
                    {{ profile.info.description }}
                  </p>
                </div>
                <p>
                  <v-icon small class="fa-fw mr-2">far fa-envelope</v-icon>
                  {{ profile.info.email }}
                </p>

                <v-row align="center" no-gutters>
                  <v-col cols="12" md="6" lg="3" class="">
                    <div class="title font-weight-bold">
                      {{ profile.allViewCountOwner | localeNumber }}
                      <span class="caption font-weight-ligth">Views</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" lg="3" class="">
                    <div class="title font-weight-bold">
                      {{ profile.allCountMyLibOwner | localeNumber }}
                      <span class="caption font-weight-ligth">Students</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" lg="3" class="">
                    <div class="title font-weight-bold">
                      {{ profile.courseOwnerCount | localeNumber }}
                      <span class="caption font-weight-ligth">Courses</span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6" lg="3" class="align-self-center">
                    <div class="d-flex">
                      <div>
                        <v-rating
                          half-increments
                          half-icon="fas fa-star-half-alt"
                          background-color="grey"
                          color="amber"
                          readonly
                          dense
                          small
                          :value="profile.avgRating"
                        ></v-rating>
                      </div>
                      <div class="ml-2 flex-grow-1">
                        <span>{{ profile.avgRating | numFormat("0.0") }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-sheet>

          <!-- <v-sheet class="pa-0 ma-2">
            <div
              class="pt-2 subtitle-1 grey--text text--darken-2 text-uppercase font-weight-bold"
            >
              About
            </div>
            <div class="body-2 mt-2" v-html="profile.info.description"></div>
          </v-sheet> -->

          <!-- <v-sheet class="pa-0 ma-2 mt-4">
            <div
              class="pt-2 subtitle-1 grey--text text--darken-2 text-uppercase font-weight-bold"
            >
              Contact
            </div>
            <div class="body-2 mt-2" v-html="profile.info.email"></div>
          </v-sheet> -->

          <!-- <template v-if="profile.courseOwner != null && profile.courseOwner.length > 0">
            <v-sheet class="pa-0 ma-2 mt-10">
              <div
                class="pt-2 subtitle-1 grey--text text--darken-2 text-uppercase font-weight-bold"
              >Portfolio</div>

              <course-vertical-grid-view :content="{title: null, body: profile.courseOwner}"></course-vertical-grid-view>
            </v-sheet>
          </template> -->
          <!-- <v-row
            justify="center"
            v-if="
              profile.courseOwner == null || profile.courseOwner.length == 0
            "
          >
            <v-col cols="12" class="text-center my-7">
              <p class="title font-weight-light grey--text">
                No data available !
              </p>
            </v-col>
          </v-row> -->

          <template
            v-if="
              profile.courseOwner != null && profile.courseOwner.length >= 0
            "
          >
            <!-- <course-vertical-grid-view
              :content="{ body: courseProfile }"
            ></course-vertical-grid-view> -->
            <section>
              <!-- <div class="mb-2 pt-5">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="headline" v-text="content.title"></div>
          <div
            class="subtitle-1 grey--text text--darken-2"
            v-text="content.subtitle"
          ></div>
        </div>
        <template v-if="content.headerButton != null">
          <div class="flex-shrink-1">
            <v-btn
              class="text-capitalize"
              text
              :color="$buttonColor"
              @click="more('header')"
            >
              {{ content.headerButton.title }}
              <v-icon right small>far fa-chevron-right</v-icon>
            </v-btn>
          </div>
        </template>
      </div>
    </div> -->
              <v-row class="pt-5">
                <v-col cols="12" class="px-0">
                  <v-toolbar flat dense color="#fafafa">
                    <v-toolbar-title
                      class="contentHeader grey--text title px-0"
                      v-if="$vuetify.breakpoint.lgAndUp"
                    >
                      Courses (<span class="font-weight-black">{{
                        courseProfile.data.length
                      }}</span
                      >)</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-menu offset-y left>
                      <template v-slot:activator="{ on }">
                        <v-btn text :color="$buttonColor" v-on="on">
                          <v-icon left>{{
                            sortOrder == 1
                              ? "far fa-sort-amount-up-alt"
                              : "far fa-sort-amount-down-alt"
                          }}</v-icon
                          >Sort
                        </v-btn>
                      </template>

                      <div class="white">
                        <div class="pa-4 pb-0">
                          <v-btn-toggle
                            mandatory
                            v-model="sortOrder"
                            @change="changeSortOrder"
                          >
                            <v-btn small>Ascending</v-btn>
                            <v-btn small>Descending</v-btn>
                          </v-btn-toggle>
                        </div>
                        <v-divider class="my-2"></v-divider>
                        <v-list tile class="pt-0" dense min-width="240px">
                          <template v-for="(item, index) in sortByOptions">
                            <v-list-item
                              :key="`sortBy_${index}`"
                              @click="updateUrl('sortby', item)"
                              :class="{
                                'primary--text v-list-item--active':
                                  (sortBy || null) == item.param,
                              }"
                            >
                              <v-list-item-title>{{
                                item.text
                              }}</v-list-item-title>
                            </v-list-item>
                            <v-divider
                              v-if="index != sortByOptions.length - 1"
                              :key="`div_sortBy_${index}`"
                            ></v-divider>
                          </template>
                        </v-list>
                      </div>
                    </v-menu>
                    <!-- <div class="py-2 ml-3 mr-2 fill-height">
            <v-divider vertical></v-divider>
          </div>
          <v-menu offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn text :color="$buttonColor" v-on="on">
                <v-avatar size="24" class="grey lighten-2 mr-2">
                  <span class="overline">{{ itemsPerPage }}</span> </v-avatar
                >Limit
              </v-btn>
            </template>
            <div class="pa-0">
              <v-list dense>
                <template v-for="(item, index) in pagingOptions">
                  <v-list-item
                    :key="`ipp_${index}`"
                    @click="updateUrl('ipp', item)"
                    :class="{
                      'primary--text v-list-item--active': item == itemsPerPage,
                    }"
                  >
                    <v-list-item-title>{{ item }}</v-list-item-title>
                  </v-list-item>
                  <v-divider
                    v-if="index != pagingOptions.length - 1"
                    :key="`div_ipp_${index}`"
                  ></v-divider>
                </template>
              </v-list>
            </div>
          </v-menu> -->
                  </v-toolbar>
                </v-col>
              </v-row>

              <v-row>
                <template v-for="item in courseProfile.data">
                  <v-col
                    cols="12"
                    sm="6"
                    lg="4"
                    xl="3"
                    class="pr-5"
                    :key="`course_${item._id}`"
                    @click="navigate(item)"
                  >
                    <v-hover v-slot:default="{ hover }">
                      <v-card
                        class="recCourseCustomCard hoverable card-growable"
                        elevation="0"
                        ripple=""
                      >
                        <v-img
                          class="recCourseImage"
                          :src="item.image"
                          :lazy-src="item.image"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-sheet
                                width="100%"
                                height="100%"
                                color="grey lighten-3"
                                class="d-flex justify-center"
                              >
                                <v-icon x-large color="grey lighten-1"
                                  >mdi mdi-image-area</v-icon
                                >
                              </v-sheet>
                            </v-row>
                          </template>
                        </v-img>
                        <v-row>
                          <v-col>
                            <div
                              :style="{
                                color: `${$themeColor}`,
                                fontSize: `13px`,
                                fontWeight: `500`,
                                marginTop: `8px`,
                                marginBottom: `8px`,
                              }"
                              v-text="item.categories[0].title"
                            ></div>
                            <div class="myCourseTitle">{{ item.title }}</div>
                            <div class="recInstructor">
                              {{ item.owner_by_students[0]._id.displayName }}
                            </div>
                            <div class="d-flex" style="align-items: center">
                              <div>
                                <v-rating
                                  half-increments
                                  half-icon="fas fa-star-half-alt"
                                  background-color="grey"
                                  color="amber"
                                  readonly
                                  dense
                                  x-small
                                  :value="item.rating"
                                ></v-rating>
                              </div>
                              <div class="ml-2 my-auto flex-grow-1">
                                <p class="mt-1 mb-0 body-2">
                                  {{ item.rating }}
                                </p>
                              </div>
                              <v-spacer></v-spacer>
                              <div class="ml-2 flex-grow-1 text-end">
                                <p
                                  v-if="item.bundle.length"
                                  class="mb-0 subtitle-1 font-weight-black"
                                >
                                  ฿{{
                                    item.bundle.length
                                      ? numberWithCommas(item.bundle[0].price)
                                      : 0
                                  }}
                                </p>
                                <p
                                  v-else
                                  class="mb-0 subtitle-1 font-weight-black"
                                >
                                  Free
                                </p>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-hover>
                  </v-col>
                </template>
              </v-row>
            </section>
          </template>

          <v-row class="pt-5" justify="end">
            <v-pagination
              v-model="page"
              :length="pageCount"
              @input="changePage"
              :color="$buttonColor"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
            ></v-pagination>
          </v-row>

          <!-- <template
            v-if="
              profile.relatedCourse != null && profile.relatedCourse.length > 0
            "
          >
            <v-sheet class="pa-0 ma-2 mt-10">
              <div
                class="pt-2 subtitle-1 grey--text text--darken-2 text-uppercase font-weight-bold"
              >
                Relate Courses
              </div>
              <course-vertical-grid-view
                :content="{ title: null, body: profile.relatedCourse }"
              ></course-vertical-grid-view>
            </v-sheet>
          </template> -->
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CourseVerticalGridView from "@/components/CourseVerticalGridViewNoLimit.vue";
// import CourseVerticalGridView from "@/components/home_v2/NewCourseVerticalGridView.vue";
function compare(a, b) {
  if (a.price < b.price) {
    return -1;
  }
  if (a.price > b.price) {
    return 1;
  }
  return 0;
}
export default {
  components: {
    CourseVerticalGridView,
  },
  data: () => ({
    loading: false,
    profile: null,
    courseProfile: {
      data: [],
    },
    showSkeleton: true,
    sort: "created_at",
    sortby: 1,
    limit: 9,
    page: 1,
    pageCount: 0,
    default_limit: 3,
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: "created_at",
    sortOrder: 1,
    reloadMode: true,
    pagingOptions: [3, 10, 20, 30],
    sortByOptions: [
      {
        param: "created_at",
        text: "Created",
      },
      {
        param: "title",
        text: "Title",
      },
      {
        param: "rating",
        text: "Rating",
      },
    ],
    name: "course_vertical_gridview",
  }),
  computed: {
    lgComputed() {
      if (this.lg != null && this.lg != 0) {
        return this.lg;
      }

      return 3;
    },
    mdComputed() {
      if (this.md != null && this.md != 0) {
        return this.md;
      }

      return 4;
    },
  },
  async mounted() {
    await this.init();
    await this.fetchBundle();
  },
  watch: {
    $route(to, from) {
      // this.init();
      this.loadCourse();
    },
  },
  methods: {
    init() {
      this.fetch();
    },
    async changePage(page) {
      this.page = page;
      await this.loadCourse();
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    fetchBundle() {
      var sortable = [];
      this.courseProfile.data.forEach((element) => {
        if (element.bundle.length) {
          sortable = element.bundle.sort(compare);
        } else {
          // no bundle
        }
      });
    },
    fetch() {
      this.profile = null;
      this.courseProfile = null;
      this.showSkeleton = true;
      this.$http
        .get(
          `${this.$store.state.api}/account/profile/teacher?id=${this.$route.params.id}`
        )
        .then((resp) => {
          if (resp.data.status == true) {
            this.profile = resp.data.result;
          } else {
            this.profile = null;
          }
        })
        .catch((err) => {
          this.profile = null;
        });

      this.$http
        .get(
          `${this.$store.state.api}/account/profile/courseteacher?id=${this.$route.params.id}&page=${this.page}&limit=${this.limit}&sort=${this.sort}&sortby=${this.sortby}`
        )
        .then((resp) => {
          if (resp.data.status == true) {
            this.courseProfile = resp.data.result;
            this.pageCount = resp.data.result.maxPage;
          } else {
            this.courseProfile = null;
          }
        })
        .catch((err) => {
          this.courseProfile = null;
        })
        .finally(() => {
          this.showSkeleton = false;
        });
    },
    changeSortOrder(val) {
      this.updateUrl("sortorder", val);
    },
    updateUrl(flag, value) {
      if (this.reloadMode) {
        let qs = this.$utility.vueRouterQueryToJson(this.$route.query);

        if (flag == "sortorder") {
          qs.sortby = this.$utility.getApiSortOrder(value);
        } else if (flag == "sortby") {
          qs.sort = value.param;
          this.sortBy = value.param;
        } else if (flag == "ipp") {
          qs.limit = value;
          this.itemsPerPage = value;
        } else if (flag == "page") {
          qs.page = value;
        }
        this.loadCourse();
        this.$nextTick(() => {
          this.$router
            .replace({
              query: qs,
            })
            .catch(() => {
              // do nothing
              // window.location = "/course?" + this.$utility.routerQueryStringToUrlParams(qs);
            });
        });
      } else {
        if (flag == "sortorder") {
          // this.sortOrder = value;
        } else if (flag == "sortby") {
          this.sortBy = value;
        } else if (flag == "ipp") {
          this.itemsPerPage = value;
        }
        this.loadCourse();
      }
    },
    loadCourse() {
      this.courseLoader = true;
      this.courseProfile = null;
      this.createCourseRequest()
        .then((resp) => {
          // if (resp.status == 200) {
          this.courseProfile = resp.data.result;
          // this.content = resp.data.result;
          // }
        })
        .catch((err) => {})
        .finally(() => {
          this.showSkeleton = false;
          setTimeout(() => {
            this.courseLoader = false;
          }, 500);
        });
    },
    createCourseRequest() {
      let url = `${this.$store.state.api}`;
      let stdParams = {
        sort: this.sortBy,
        sortby: this.$utility.getApiSortOrder(this.sortOrder),
        page: this.page,
        limit: this.limit,
      };
      url += `/account/profile/courseteacher?id=${
        this.$route.params.id
      }&${this.$utility.routerQueryStringToUrlParams(stdParams)}`;

      return this.$http.get(url);
    },
    navigate(item) {
      this.$router.push({
        name: "course_detail",
        params: {
          id: item._id,
        },
      });
    },
  },
};
</script>
<style scoped>
.myCourseCatagory {
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #4a90e2;
}
.myCourseTitle {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  color: #4a4a4a;
  margin-bottom: 0px;

  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* min-height: 35px;
  max-height: 43px; */
}

.recCourseCustomCard {
  border-radius: 4px;
  border: solid 1px #dcdcdc;
  background-color: #ffffff;
  padding: 15px 15px 15px 15px;
}

.recCourseImage {
  width: 100%;
  height: 200px;
}

.recInstructor {
  font-size: 14px;
  line-height: 1.57;
  color: #9b9b9b;
  margin-top: 8px;
  margin-bottom: 8px;
}

.checked {
  color: #fadb14;
  font-size: 16px;
}

.unchecked {
  color: rgba(0, 0, 0, 0.04);
  font-size: 16px;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip) {
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}
</style>
